import React from 'react';
import '../styles/Footer.scss';
import bluelogo from '../imgs/LIVeasy_blue.png';

const Footer = () => {

  return (
    <div id='footer'>
      <h4>LIVEasy &copy;</h4>
      {/* <img src={bluelogo} alt='logo' /> */}
    </div>
  )
}

export default Footer;